export type SystemApp = {
  id: string
  name: string
  icon: string
  link: string
  visibility: 'authenticated' | 'admin'
  category: 'system' | 'management'
  order: number
}

export const shellSystemApps: SystemApp[] = [
  {
    id: 'admin',
    name: 'Admin Panel',
    icon: 'ri-admin-line',
    link: '/admin',
    visibility: 'admin',
    category: 'system',
    order: 200,
  },
]
